import {useState, useEffect} from 'react';
import Timer from '../../../../../../../utils/timer';

export default ({timestamp}) => {
    const [time, setTime] = useState(timestamp - Date.now());

    useEffect(() => {
        window.sliderWelcomeBonusTimeout = setTimeout(() => {
            setTime(timestamp - Date.now())
        }, 800);

        return () => clearTimeout(window.sliderWelcomeBonusTimeout);
    }, [time]);

    const timer = Timer.parse(timestamp, true);

    return (
        <div className="tournament-timer">
            <div className="timer-zone">
                <div className="value">{timer.days}</div>
                <div className="title">DAYS</div>
            </div>
            <div className="timer-zone">
                <div className="value">{timer.hours}</div>
                <div className="title">HOURS</div>
            </div>
            <div className="timer-zone">
                <div className="value">{timer.minutes}</div>
                <div className="title">MINUTES</div>
            </div>
        </div> 
    )
}